<template>
  <div>
    <navigation-bar></navigation-bar>

    <div class="master-page">
      <div class="master-toolbar">
        <div>
          <h3 class="page-title">Import törzsadatok</h3>
          <div class="text-muted small">
            Napok, diszpécserek és grid beállítása
          </div>
        </div>

        <div class="toolbar-actions">
          <button
            class="btn btn-sm btn-outline-secondary"
            @click="goBackToImportWeek"
          >
            Vissza
          </button>

          <button class="btn btn-sm btn-primary" @click="loadCurrent">
            Betöltés
          </button>

          <button class="btn btn-sm btn-success" @click="saveCurrent">
            Mentés
          </button>
        </div>
      </div>

      <div v-if="error" class="alert alert-danger py-2">
        {{ error }}
      </div>

      <div v-if="message" class="alert alert-success py-2">
        {{ message }}
      </div>

      <ul class="nav nav-tabs mb-2">

        <li class="nav-item">
          <a
            href="#"
            class="nav-link"
            :class="{ active: activeTab === 'sections' }"
            @click.prevent="setTab('sections')"
          >
            Grid - feladatok
          </a>
        </li>



        <li class="nav-item">
          <a
            href="#"
            class="nav-link"
            :class="{ active: activeTab === 'days' }"
            @click.prevent="setTab('days')"
          >
            Napok
          </a>
        </li>

        <li class="nav-item">
          <a
            href="#"
            class="nav-link"
            :class="{ active: activeTab === 'dispatchers' }"
            @click.prevent="setTab('dispatchers')"
          >
            Diszpécserek
          </a>
        </li>


      </ul>

      <div class="tab-actions">
        <button class="btn btn-sm btn-outline-primary" @click="addRow">
          + Új sor
        </button>
      </div>

      <!-- Napok -->
      <div v-if="activeTab === 'days'" class="table-wrap">
        <table class="table table-sm table-bordered master-table">
          <thead>
            <tr>
              <th>Sorrend</th>
              <th>Weekday</th>
              <th>Név</th>
              <th>Rövid név</th>
              <th>Aktív</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="row in days" :key="row._key">
              <td>
                <input
                  v-model.number="row.sort_order"
                  type="number"
                  class="form-control form-control-sm small-number"
                >
              </td>

              <td>
                <input
                  v-model.number="row.weekday_no"
                  type="number"
                  class="form-control form-control-sm small-number"
                >
              </td>

              <td>
                <input v-model="row.day_name" class="form-control form-control-sm">
              </td>

              <td>
                <input v-model="row.short_name" class="form-control form-control-sm">
              </td>

              <td class="text-center">
                <input v-model="row.active" type="checkbox" true-value="1" false-value="0">
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Diszpécserek -->
      <div v-if="activeTab === 'dispatchers'" class="table-wrap">
        <table class="table table-sm table-bordered master-table">
          <thead>
            <tr>
              <th>Sorrend</th>
              <th>Diszpécser név</th>
              <th>Diszpécser AZ</th>
              <th>Aktív</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="row in dispatchers" :key="row._key">
              <td>
                <input
                  v-model.number="row.sort_order"
                  type="number"
                  class="form-control form-control-sm small-number"
                >
              </td>

              <td>
                <input v-model="row.diszpecser_nev" class="form-control form-control-sm">
              </td>

              <td>
                <input
                  v-model.number="row.diszpecser_az"
                  type="number"
                  class="form-control form-control-sm medium-number"
                >
              </td>

              <td class="text-center">
                <input v-model="row.active" type="checkbox" true-value="1" false-value="0">
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Szekciók: 1 rekord = 2 sor -->
      <div v-if="activeTab === 'sections'" class="table-wrap sections-table-wrap">
        <table class="table table-sm table-bordered master-table sections-table">
          <thead>
            <tr>
              <th rowspan="2" class="col-sort">Sorrend</th>
              <th rowspan="2" class="col-active">Aktív</th>

              <th class="col-key-name">Kulcs</th>
              <th class="col-customer-product">Megrendelő</th>
              <th class="col-place">Felrakó</th>
              <th class="col-place">Lerakó</th>
              <th class="col-price">Nagyár</th>
              <th class="col-reference">Hivatkozás</th>
              <th class="col-km">Terv.menny</th>
              <th class="col-qty">Fuvarszervező</th>
            </tr>

            <tr class="sections-subheader">
              <th>Név</th>
              <th>Cikk</th>
              <th>Felrakóhely</th>
              <th>Lerakóhely</th>
              <th>Kisár</th>
              <th>Belső hivatkozás</th>
              <th>KM</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <template v-for="row in sections" :key="row._key">
              <!-- Rekord 1. sora -->
              <tr
                class="section-record-first"
                :class="{ 'protected-section-row': isProtectedSection(row) }"
              >
                <!-- Sorrend: mindkét sorhoz tartozik -->
                <td rowspan="2" class="section-rowspan-cell text-center">
                  <input
                    v-model.number="row.sort_order"
                    type="number"
                    class="form-control form-control-sm small-number"
                    :disabled="isProtectedSection(row)"
                  >
                </td>

                <!-- Aktív: mindkét sorhoz tartozik -->
                <td rowspan="2" class="section-rowspan-cell text-center">
                  <input
                    v-model="row.active"
                    type="checkbox"
                    true-value="1"
                    false-value="0"
                    :disabled="isProtectedSection(row)"
                  >
                </td>

                <!-- Kulcs -->
                <td>
                  <input
                    v-model.trim="row.section_key"
                    class="form-control form-control-sm key-input"
                    :disabled="isProtectedSection(row)"
                  >
                </td>

                <!-- Megrendelő -->
                <td class="megrendelo-cell">
                  <input
                    v-model="row.megrendelo_nev"
                    class="form-control form-control-sm megrendelo-input"
                    placeholder="Keresés..."
                    :disabled="isProtectedSection(row)"
                    @input="onMegrendeloInput(row)"
                    @blur="onMegrendeloBlur(row)"
                  >

                  <div
                    v-if="megrendeloOptions[row._key] && megrendeloOptions[row._key].length > 0"
                    class="megrendelo-suggestions"
                  >
                    <button
                      v-for="item in megrendeloOptions[row._key]"
                      :key="item.v_kod"
                      type="button"
                      class="megrendelo-suggestion"
                      @mousedown.prevent="selectMegrendelo(row, item)"
                    >
                      <strong>{{ item.v_nev1 }}</strong>
                      <span>{{ item.v_kod }}</span>
                    </button>
                  </div>
                </td>

                <!-- Felrakó -->
                <td class="tav-cell">
                  <input
                    v-model="row.felrako_nev"
                    class="form-control form-control-sm place-input"
                    placeholder="Felrakó keresés..."
                    :disabled="isProtectedSection(row)"
                    @input="onFelrakoInput(row)"
                    @blur="onFelrakoBlur(row)"
                  >

                  <div
                    v-if="felrakoOptions[row._key] && felrakoOptions[row._key].length > 0"
                    class="tav-suggestions"
                  >
                    <button
                      v-for="item in felrakoOptions[row._key]"
                      :key="item.tav_az"
                      type="button"
                      class="tav-suggestion"
                      @mousedown.prevent="selectFelrako(row, item)"
                    >
                      <strong>{{ item.tav_megn }}</strong>
                      <span>{{ item.tav_az }}</span>
                    </button>
                  </div>
                </td>

                <!-- Lerakó -->
                <td class="tav-cell">
                  <input
                    v-model="row.lerako_nev"
                    class="form-control form-control-sm place-input"
                    placeholder="Lerakó keresés..."
                    :disabled="isProtectedSection(row)"
                    @input="onLerakoInput(row)"
                    @blur="onLerakoBlur(row)"
                  >

                  <div
                    v-if="lerakoOptions[row._key] && lerakoOptions[row._key].length > 0"
                    class="tav-suggestions"
                  >
                    <button
                      v-for="item in lerakoOptions[row._key]"
                      :key="item.tav_az"
                      type="button"
                      class="tav-suggestion"
                      @mousedown.prevent="selectLerako(row, item)"
                    >
                      <strong>{{ item.tav_megn }}</strong>
                      <span>{{ item.tav_az }}</span>
                    </button>
                  </div>
                </td>

                <!-- Nagyár + nagydeviza -->
                <td>
                  <div class="price-inline">
                    <input
                      v-model.number="row.nagyar"
                      type="number"
                      step="0.01"
                      class="form-control form-control-sm price-input"
                      :disabled="isProtectedSection(row)"
                    >

                    <input
                      v-model.trim="row.nagydeviza"
                      maxlength="10"
                      class="form-control form-control-sm deviza-input"
                      placeholder="€"
                      :disabled="isProtectedSection(row)"
                    >
                  </div>
                </td>

                <!-- Hivatkozás = m_megrendeles -->
                <td>
                  <input
                    v-model.trim="row.m_megrendeles"
                    type="text"
                    maxlength="50"
                    class="form-control form-control-sm reference-input"
                    :disabled="isProtectedSection(row)"
                  >
                </td>

                <!-- Terv mennyiség:  -->
                <td>
                  <input
                    v-model.number="row.terv_mennyiseg"
                    type="number"
                    step="1"
                    class="form-control form-control-sm qty-input"
                    :disabled="isProtectedSection(row)"
                  >
                </td>

                <!-- Fuvarszervezo -->
                <td>
                  <select
                    :value="row.m_fuvarszaz || ''"
                    class="form-control form-control-sm fuvarszervezo-input"
                    :disabled="isProtectedSection(row)"
                    @change="
                      onFuvarszervezoChange(
                        row,
                        $event.target.value
                      )
                    "
                  >
                    <option value="">
                      -- válasszon --
                    </option>

                    <option
                      v-for="item in fuvarszervezoOptions"
                      :key="item.m_fuvarszaz"
                      :value="item.m_fuvarszaz"
                    >
                      {{ item.fuvarszervezo }}
                    </option>
                  </select>
                </td>

              </tr>

              <!-- Rekord 2. sora -->
              <tr
                class="section-record-second"
                :class="{ 'protected-section-row': isProtectedSection(row) }"
              >
                <!-- Név -->
                <td>
                  <input
                    v-model.trim="row.section_name"
                    class="form-control form-control-sm name-input"
                    :disabled="isProtectedSection(row)"
                  >
                </td>

                <!-- Cikk -->
                <td class="cikk-cell">
                  <input
                    v-model="row.product_name"
                    class="form-control form-control-sm name-input"
                    placeholder="Cikk keresés..."
                    :disabled="isProtectedSection(row)"
                    @input="onCikkInput(row)"
                    @blur="onCikkBlur(row)"
                  >

                  <div
                    v-if="cikkOptions[row._key] && cikkOptions[row._key].length > 0"
                    class="cikk-suggestions"
                  >
                    <button
                      v-for="item in cikkOptions[row._key]"
                      :key="item.cikk_az"
                      type="button"
                      class="cikk-suggestion"
                      @mousedown.prevent="selectCikk(row, item)"
                    >
                      <strong>{{ item.cikk_megn }}</strong>
                      <span>{{ item.cikk_az }}</span>
                    </button>
                  </div>
                </td>

                <!-- Felrakóhely -->
                <td class="hely-cell">
                  <input
                    v-model="row.felhely_nev"
                    class="form-control form-control-sm place-input"
                    placeholder="Felrakóhely keresés..."
                    :disabled="isProtectedSection(row) || !row.felrako_az"
                    @input="onFelhelyInput(row)"
                    @blur="onFelhelyBlur(row)"
                  >

                  <div
                    v-if="felhelyOptions[row._key] && felhelyOptions[row._key].length > 0"
                    class="hely-suggestions"
                  >
                    <button
                      v-for="item in felhelyOptions[row._key]"
                      :key="item.hely_az"
                      type="button"
                      class="hely-suggestion"
                      @mousedown.prevent="selectFelhely(row, item)"
                    >
                      <strong>{{ helyLabel(item) }}</strong>
                      <span>{{ item.hely_az }}</span>
                    </button>
                  </div>
                </td>

                <!-- Lerakóhely -->
                <td class="hely-cell">
                  <input
                    v-model="row.lerhely_nev"
                    class="form-control form-control-sm place-input"
                    placeholder="Lerakóhely keresés..."
                    :disabled="isProtectedSection(row) || !row.lerako_az"
                    @input="onLerhelyInput(row)"
                    @blur="onLerhelyBlur(row)"
                  >

                  <div
                    v-if="lerhelyOptions[row._key] && lerhelyOptions[row._key].length > 0"
                    class="hely-suggestions"
                  >
                    <button
                      v-for="item in lerhelyOptions[row._key]"
                      :key="item.hely_az"
                      type="button"
                      class="hely-suggestion"
                      @mousedown.prevent="selectLerhely(row, item)"
                    >
                      <strong>{{ helyLabel(item) }}</strong>
                      <span>{{ item.hely_az }}</span>
                    </button>
                  </div>
                </td>

                <!-- Kisár + kisdeviza -->
                <td>
                  <div class="price-inline">
                    <input
                      v-model.number="row.kisar"
                      type="number"
                      step="0.01"
                      class="form-control form-control-sm price-input"
                      :disabled="isProtectedSection(row)"
                    >

                    <input
                      v-model.trim="row.kisdeviza"
                      maxlength="10"
                      class="form-control form-control-sm deviza-input"
                      placeholder="€"
                      :disabled="isProtectedSection(row)"
                    >
                  </div>
                </td>

                <!-- Belső hivatkozás -->
                <td>
                  <input
                    v-model.trim="row.belsoHivatkozas"
                    type="text"
                    maxlength="50"
                    class="form-control form-control-sm reference-input"
                    :disabled="isProtectedSection(row)"
                  >
                </td>

              

                <!-- KM -->
                <td>
                  <input
                    v-model.number="row.m_km"
                    type="number"
                    step="0.1"
                    class="form-control form-control-sm km-input"
                    :disabled="isProtectedSection(row)"
                  >
                </td>

                <td></td>

              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationBar from '@/views/NavigationBar.vue'
import {
  fetchImportCfg,
  saveImportCfg,
  searchMegrendelo,
  searchCikk,
  searchTav,
  searchHely,
  fetchImportFuvarszervezok
} from '@/api/importPlanApi'
import { mapGetters } from 'vuex'

export default {
  name: 'ImportMasterDataView',

  components: {
    NavigationBar
  },

  data() {
    return {

      activeTab: 'sections',

      days: [],
      dispatchers: [],
      sections: [],

      error: '',
      message: '',

      megrendeloOptions: {},
      megrendeloTimers: {},

      cikkOptions: {},
      cikkTimers: {},

      felrakoOptions: {},
      felrakoTimers: {},

      lerakoOptions: {},
      lerakoTimers: {},

      felhelyOptions: {},
      felhelyTimers: {},

      lerhelyOptions: {},
      lerhelyTimers: {},
      fuvarszervezoOptions: [],

    }
  },

  computed: {
    ...mapGetters(['getUserData']),

    cegAz() {
      return this.getUserData && this.getUserData.ceg_az
        ? Number(this.getUserData.ceg_az)
        : 0
    }
  },

  mounted() {
    if (this.cegAz > 0) {
      this.loadAll()
    }
  },

  methods: {

   normalizeNullableNumber(value) {
  if (
    value === null ||
    value === undefined ||
    value === ''
  ) {
    return null
  }

  const normalized = String(value)
    .replace(',', '.')
    .trim()

  const numberValue = Number(normalized)

  if (!Number.isFinite(numberValue)) {
    return null
  }

  return numberValue
},

roundIntegerValue(value) {
  const numberValue = this.normalizeNullableNumber(value)

  if (numberValue === null) {
    return null
  }

  return Math.round(numberValue)
},

roundOneDecimalValue(value) {
  const numberValue = this.normalizeNullableNumber(value)

  if (numberValue === null) {
    return null
  }

  return Math.round(numberValue * 10) / 10
},

onTervMennyisegBlur(row) {
  row.terv_mennyiseg = this.roundIntegerValue(
    row.terv_mennyiseg
  )
},

onKmBlur(row) {
  row.m_km = this.roundOneDecimalValue(
    row.m_km
  )
},

normalizeSectionNumberFields(row) {
  return {
    ...row,
    terv_mennyiseg: this.roundIntegerValue(row.terv_mennyiseg),
    m_km: this.roundOneDecimalValue(row.m_km)
  }
}, 


/****  fuvarszervezo */
async loadFuvarszervezoOptions() {
  try {
    const data = await fetchImportFuvarszervezok({
      ceg_az: this.cegAz
    })

    if (!data.success) {
      throw new Error(
        data.message ||
        'A fuvarszervezők betöltése sikertelen.'
      )
    }

    this.fuvarszervezoOptions = Array.isArray(data.rows)
      ? data.rows
      : []
  } catch (e) {
    this.fuvarszervezoOptions = []

    this.error =
      (e.response &&
        e.response.data &&
        e.response.data.message) ||
      e.message ||
      'A fuvarszervezők betöltése sikertelen.'
  }
},


onFuvarszervezoChange(row, value) {
  const selectedAz =
    value !== null &&
    value !== undefined &&
    String(value).trim() !== ''
      ? Number(value)
      : null

  row.m_fuvarszaz = selectedAz

  const selected = this.fuvarszervezoOptions.find(
    (item) =>
      Number(item.m_fuvarszaz) === selectedAz
  )

  row.fuvarszervezo = selected
    ? selected.fuvarszervezo
    : ''
},



/************* */
getNextSectionSortOrder() {
  const sortOrders = this.sections
    .filter((row) => !this.isProtectedSection(row))
    .map((row) => Number(row.sort_order))
    .filter((value) => Number.isFinite(value))

  const highestSortOrder =
    sortOrders.length > 0
      ? Math.max(...sortOrders)
      : 10

  return Math.max(20, highestSortOrder + 10)
},


/****  vissza */

goBackToImportWeek() {
  if (this.$route.query.returnTo) {
    this.$router.push(String(this.$route.query.returnTo))
    return
  }

  this.$router.push('/import-munkak')
},

/****  day_matrix Zeile schreibgeschützt */
isProtectedSection(row) {
  if (!row) {
    return false
  }

  return row.layout_type === 'DAY_MATRIX' || row.section_key === 'NAPI_DISZPO'
},

normalizeProtectedSection(row) {
  const normalizedRow = {
    ...row,
    egy_sor_mennyiseg: 25
  }

  if (!this.isProtectedSection(normalizedRow)) {
    return normalizedRow
  }

  return {
    ...normalizedRow,
    sort_order: 10,
    active: '1',
    layout_type: 'DAY_MATRIX',
    section_key: 'NAPI_DISZPO',
    section_name: normalizedRow.section_name || 'Napi diszpó / saját autók',
    belsoHivatkozas: '',
    m_megrendeles: '',
      m_km: null,
    m_fuvarszaz: null,
    fuvarszervezo: '',
  }
},


/****** lerako hely */
onLerhelyInput(row) {
  const key = row._key
  const searchText = String(row.lerhely_nev || '').trim()

  row.lerhely_az = null

  if (this.lerhelyTimers[key]) {
    clearTimeout(this.lerhelyTimers[key])
  }

  if (!row.lerako_az) {
    this.lerhelyOptions = {
      ...this.lerhelyOptions,
      [key]: []
    }
    return
  }

  if (searchText.length < 1) {
    this.lerhelyOptions = {
      ...this.lerhelyOptions,
      [key]: []
    }
    return
  }

  this.lerhelyTimers[key] = setTimeout(() => {
    this.loadLerhelyOptions(row, searchText)
  }, 250)
},

async loadLerhelyOptions(row, searchText) {
  const key = row._key

  try {
    const data = await searchHely({
      hely_tavaz: row.lerako_az
    })

    const searchLower = String(searchText || '').toLowerCase()

    const rows = this.normalizeHelyRows(data).filter((item) => {
      const label = this.helyLabel(item).toLowerCase()
      return label.includes(searchLower)
    })

    this.lerhelyOptions = {
      ...this.lerhelyOptions,
      [key]: rows
    }
  } catch (e) {
    void e

    this.lerhelyOptions = {
      ...this.lerhelyOptions,
      [key]: []
    }
  }
},

selectLerhely(row, item) {
  row.lerhely_az = item.hely_az ? Number(item.hely_az) : null
  row.lerhely_nev = this.helyLabel(item)

  this.lerhelyOptions = {
    ...this.lerhelyOptions,
    [row._key]: []
  }
},

onLerhelyBlur(row) {
  setTimeout(() => {
    this.lerhelyOptions = {
      ...this.lerhelyOptions,
      [row._key]: []
    }

    if (!row.lerhely_nev) {
      row.lerhely_az = null
    }
  }, 200)
},


/*****  felhely */
normalizeHelyRows(data) {
  if (!data) {
    return []
  }

  if (Array.isArray(data)) {
    return data
  }

  if (Array.isArray(data.data)) {
    return data.data
  }

  if (Array.isArray(data.rows)) {
    return data.rows
  }

  return []
},

helyLabel(item) {
  if (!item) {
    return ''
  }

  return [
    item.hely_ceg || '',
    item.hely_cim || '',
    item.hely_megj || ''
  ]
    .filter((value) => String(value).trim() !== '')
    .join(' - ')
},

onFelhelyInput(row) {
  const key = row._key
  const searchText = String(row.felhely_nev || '').trim()

  row.felhely_az = null

  if (this.felhelyTimers[key]) {
    clearTimeout(this.felhelyTimers[key])
  }

  if (!row.felrako_az) {
    this.felhelyOptions = {
      ...this.felhelyOptions,
      [key]: []
    }
    return
  }

  if (searchText.length < 1) {
    this.felhelyOptions = {
      ...this.felhelyOptions,
      [key]: []
    }
    return
  }

  this.felhelyTimers[key] = setTimeout(() => {
    this.loadFelhelyOptions(row, searchText)
  }, 250)
},

async loadFelhelyOptions(row, searchText) {
  const key = row._key

  try {
    const data = await searchHely({
      hely_tavaz: row.felrako_az
    })

    const searchLower = String(searchText || '').toLowerCase()

    const rows = this.normalizeHelyRows(data).filter((item) => {
      const label = this.helyLabel(item).toLowerCase()
      return label.includes(searchLower)
    })

    this.felhelyOptions = {
      ...this.felhelyOptions,
      [key]: rows
    }
  } catch (e) {
    void e

    this.felhelyOptions = {
      ...this.felhelyOptions,
      [key]: []
    }
  }
},

selectFelhely(row, item) {
  row.felhely_az = item.hely_az ? Number(item.hely_az) : null
  row.felhely_nev = this.helyLabel(item)

  this.felhelyOptions = {
    ...this.felhelyOptions,
    [row._key]: []
  }
},

onFelhelyBlur(row) {
  setTimeout(() => {
    this.felhelyOptions = {
      ...this.felhelyOptions,
      [row._key]: []
    }

    if (!row.felhely_nev) {
      row.felhely_az = null
    }
  }, 200)
},


/*** lerako */
onLerakoInput(row) {
  const key = row._key
  const searchText = String(row.lerako_nev || '').trim()

  row.lerako_az = null

  if (this.lerakoTimers[key]) {
    clearTimeout(this.lerakoTimers[key])
  }

  if (searchText.length < 2) {
    this.lerakoOptions = {
      ...this.lerakoOptions,
      [key]: []
    }
    return
  }

  this.lerakoTimers[key] = setTimeout(() => {
    this.loadLerakoOptions(row, searchText)
  }, 300)
},

async loadLerakoOptions(row, searchText) {
  const key = row._key

  try {
    const data = await searchTav({
      search: searchText,
      ceg_az: this.cegAz
    })

    const rows = this.normalizeTavRows(data)

    this.lerakoOptions = {
      ...this.lerakoOptions,
      [key]: rows
    }
  } catch (e) {
    void e

    this.lerakoOptions = {
      ...this.lerakoOptions,
      [key]: []
    }
  }
},

selectLerako(row, item) {
  row.lerako_az = item.tav_az ? Number(item.tav_az) : null
  row.lerako_nev = item.tav_megn || ''

  /*
   * Wenn Lerakó geändert wird, ist ein eventuell gesetzter Lerhely
   * nicht mehr sicher passend.
   */
  row.lerhely_az = null
  row.lerhely_nev = ''

  this.lerakoOptions = {
    ...this.lerakoOptions,
    [row._key]: []
  }
},

onLerakoBlur(row) {
  setTimeout(() => {
    this.lerakoOptions = {
      ...this.lerakoOptions,
      [row._key]: []
    }

    if (!row.lerako_nev) {
      row.lerako_az = null
      row.lerhely_az = null
      row.lerhely_nev = ''
    }
  }, 200)
},


/***** felrako */
normalizeTavRows(data) {
  if (!data) {
    return []
  }

  if (Array.isArray(data)) {
    return data
  }

  if (Array.isArray(data.data)) {
    return data.data
  }

  if (Array.isArray(data.rows)) {
    return data.rows
  }

  return []
},

onFelrakoInput(row) {
  const key = row._key
  const searchText = String(row.felrako_nev || '').trim()

  row.felrako_az = null

  if (this.felrakoTimers[key]) {
    clearTimeout(this.felrakoTimers[key])
  }

  if (searchText.length < 2) {
    this.felrakoOptions = {
      ...this.felrakoOptions,
      [key]: []
    }
    return
  }

  this.felrakoTimers[key] = setTimeout(() => {
    this.loadFelrakoOptions(row, searchText)
  }, 300)
},

async loadFelrakoOptions(row, searchText) {
  const key = row._key

  try {
    const data = await searchTav({
      search: searchText,
      ceg_az: this.cegAz
    })

    const rows = this.normalizeTavRows(data)

    this.felrakoOptions = {
      ...this.felrakoOptions,
      [key]: rows
    }
  } catch (e) {
    void e

    this.felrakoOptions = {
      ...this.felrakoOptions,
      [key]: []
    }
  }
},

selectFelrako(row, item) {
  row.felrako_az = item.tav_az ? Number(item.tav_az) : null
  row.felrako_nev = item.tav_megn || ''

  /*
   * Wenn Felrakó geändert wird, ist ein eventuell vorher gesetzter Felhely
   * fachlich nicht mehr sicher passend.
   */
  row.felhely_az = null
  row.felhely_nev = ''

  this.felrakoOptions = {
    ...this.felrakoOptions,
    [row._key]: []
  }
},

onFelrakoBlur(row) {
  setTimeout(() => {
    this.felrakoOptions = {
      ...this.felrakoOptions,
      [row._key]: []
    }

    if (!row.felrako_nev) {
      row.felrako_az = null
      row.felhely_az = null
      row.felhely_nev = ''
    }
  }, 200)
},



/****  cikk */
    normalizeCikkRows(data) {
      if (!data) {
        return []
      }

      if (Array.isArray(data)) {
        return data
      }

      if (Array.isArray(data.data)) {
        return data.data
      }

      if (Array.isArray(data.rows)) {
        return data.rows
      }

      return []
    },

    onCikkInput(row) {
      const key = row._key
      const searchText = String(row.product_name || '').trim()

      row.cikk_az = null

      if (this.cikkTimers[key]) {
        clearTimeout(this.cikkTimers[key])
      }

      if (searchText.length < 2) {
        this.cikkOptions = {
          ...this.cikkOptions,
          [key]: []
        }
        return
      }

      this.cikkTimers[key] = setTimeout(() => {
        this.loadCikkOptions(row, searchText)
      }, 300)
    },

    async loadCikkOptions(row, searchText) {
      const key = row._key

      try {
        const data = await searchCikk({
          ceg_az: this.cegAz,
          search: searchText
        })

        const rows = this.normalizeCikkRows(data)

        this.cikkOptions = {
          ...this.cikkOptions,
          [key]: rows
        }
      } catch (e) {
        void e

        this.cikkOptions = {
          ...this.cikkOptions,
          [key]: []
        }
      }
    },

    selectCikk(row, item) {
      row.cikk_az = item.cikk_az ? Number(item.cikk_az) : null
      row.product_name = item.cikk_megn || ''

      this.cikkOptions = {
        ...this.cikkOptions,
        [row._key]: []
      }
    },

    onCikkBlur(row) {
      setTimeout(() => {
        this.cikkOptions = {
          ...this.cikkOptions,
          [row._key]: []
        }

        if (!row.product_name) {
          row.cikk_az = null
        }
      }, 200)
    },

    //************ */   
    makeKey(prefix) {
      return prefix + '-' + Date.now() + '-' + Math.floor(Math.random() * 100000)
    },

    setTab(tab) {
      this.activeTab = tab
      this.error = ''
      this.message = ''
    },

    async loadAll() {
      await this.loadFuvarszervezoOptions()
      await this.loadCfg('days')
      await this.loadCfg('dispatchers')
      await this.loadCfg('sections')
    },

    async loadCurrent() {
      await this.loadCfg(this.activeTab)
    },

    async loadCfg(type) {
      this.error = ''
      this.message = ''

      try {
        const data = await fetchImportCfg({
          ceg_az: this.cegAz,
          type
        })

        if (!data.success) {
          throw new Error(data.message || 'Betöltés sikertelen.')
        }

          const rows = (data.rows || []).map((row, index) => {
          const normalized = this.defaultRow(type, index + 1)

          const mergedRow = {
            ...normalized,
            ...row,
            _key: type + '-' + (row.az || this.makeKey(type))
          }

          if (type === 'sections') {
            return this.normalizeSectionNumberFields(
              this.normalizeProtectedSection({
                ...mergedRow,
                egy_sor_mennyiseg: 25
              })
            )
          }

          return mergedRow
        })

        if (type === 'days') {
          this.days = rows
        }

        if (type === 'dispatchers') {
          this.dispatchers = rows
        }

        if (type === 'sections') {
          this.sections = rows
        }
      } catch (e) {
        this.error =
          (e.response && e.response.data && e.response.data.message) ||
          e.message ||
          'Betöltés sikertelen.'
      }
    },

    defaultRow(type, sortOrder) {
      if (type === 'days') {
        return {
          _key: this.makeKey('days'),
          az: null,
          sort_order: sortOrder,
          weekday_no: sortOrder,
          day_name: '',
          short_name: '',
          active: '1'
        }
      }

      if (type === 'dispatchers') {
        return {
          _key: this.makeKey('dispatchers'),
          az: null,
          sort_order: sortOrder,
          diszpecser_nev: '',
          diszpecser_az: null,
          active: '1'
        }
      }


      if (type === 'sections') {
        sortOrder = Math.max(20, Number(sortOrder) || 20)
      }

  
      return {
        _key: this.makeKey('sections'),
        az: null,
        sort_order: sortOrder,

        section_key: '',
        section_name: '',

        megrendelo_v_kod: null,
        megrendelo_nev: '',

        m_fuvarszaz: null,
        fuvarszervezo: '',

        product_name: '',
        customer_name: '',
        customer_az: null,

        felrako_az: null,
        felrako_nev: '',

        lerako_az: null,
        lerako_nev: '',

        felhely_az: null,
        felhely_nev: '',

        lerhely_az: null,
        lerhely_nev: '',

        nagyar: null,
        nagydeviza: '€',
        kisar: null,
        kisdeviza: '€',

        belsoHivatkozas: '',
        m_megrendeles: '',
        m_km: null,

        cikk_az: null,

        terv_mennyiseg: null,
        egy_sor_mennyiseg: 25,

        layout_type: 'GRID',
        default_height_px: 280,
        default_zoom_percent: 100,
        collapsed_default: '0',
        active: '1'
      }
    },

      rowsForCurrentTab() {
        if (this.activeTab === 'days') {
          return this.days
        }

        if (this.activeTab === 'dispatchers') {
          return this.dispatchers
        }

        return this.sections.map((row) => {
          return this.normalizeProtectedSection(
            this.normalizeSectionNumberFields({
              ...row,
              egy_sor_mennyiseg: 25
            })
          )
        })
      },

    addRow() {
      if (this.activeTab === 'days') {
        this.days.push(this.defaultRow('days', this.days.length + 1))
      }

      if (this.activeTab === 'dispatchers') {
        this.dispatchers.push(this.defaultRow('dispatchers', this.dispatchers.length + 1))
      }

      if (this.activeTab === 'sections') {
        const nextSortOrder = this.getNextSectionSortOrder()

        this.sections.push(
          this.defaultRow('sections', nextSortOrder)
        )
      }
    },

    async saveCurrent() {
      this.error = ''
      this.message = ''

      try {
        const data = await saveImportCfg({
          ceg_az: this.cegAz,
          type: this.activeTab,
          rows: this.rowsForCurrentTab()
        })

        if (!data.success) {
          throw new Error(data.message || 'Mentés sikertelen.')
        }

        this.message = 'Mentve.'
        await this.loadCfg(this.activeTab)
      } catch (e) {
        this.error =
          (e.response && e.response.data && e.response.data.message) ||
          e.message ||
          'Mentés sikertelen.'
      }
    },

    normalizeMegrendeloRows(data) {
      if (!data) {
        return []
      }

      if (Array.isArray(data)) {
        return data
      }

      if (Array.isArray(data.data)) {
        return data.data
      }

      if (Array.isArray(data.rows)) {
        return data.rows
      }

      return []
    },

    onMegrendeloInput(row) {
      const key = row._key
      const searchText = String(row.megrendelo_nev || '').trim()

      row.megrendelo_v_kod = null

      if (this.megrendeloTimers[key]) {
        clearTimeout(this.megrendeloTimers[key])
      }

      if (searchText.length < 2) {
        this.megrendeloOptions = {
          ...this.megrendeloOptions,
          [key]: []
        }
        return
      }

      this.megrendeloTimers[key] = setTimeout(() => {
        this.loadMegrendeloOptions(row, searchText)
      }, 300)
    },

    async loadMegrendeloOptions(row, searchText) {
      const key = row._key

      try {
        const data = await searchMegrendelo({
          search: searchText,
          ceg_az: this.cegAz
        })

        const rows = this.normalizeMegrendeloRows(data)

        this.megrendeloOptions = {
          ...this.megrendeloOptions,
          [key]: rows
        }
      } catch (e) {
        void e

        this.megrendeloOptions = {
          ...this.megrendeloOptions,
          [key]: []
        }
      }
    },

    selectMegrendelo(row, item) {
      row.megrendelo_v_kod = item.v_kod ? Number(item.v_kod) : null
      row.megrendelo_nev = item.v_nev1 || ''

      if (!row.customer_az) {
        row.customer_az = row.megrendelo_v_kod
      }

      if (!row.customer_name) {
        row.customer_name = row.megrendelo_nev
      }

      this.megrendeloOptions = {
        ...this.megrendeloOptions,
        [row._key]: []
      }
    },

    onMegrendeloBlur(row) {
      setTimeout(() => {
        this.megrendeloOptions = {
          ...this.megrendeloOptions,
          [row._key]: []
        }

        if (!row.megrendelo_nev) {
          row.megrendelo_v_kod = null
        }
      }, 200)
    }
  }
}
</script>

<style scoped>
.master-page {
  padding: 12px;
}

.master-toolbar {
  position: sticky;
  top: 0;
  z-index: 1500;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  margin-bottom: 12px;
  padding: 10px;

  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 6px;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.page-title {
  margin: 0;
  font-size: 20px;
}

.toolbar-actions {
  display: flex;
  gap: 6px;
  align-items: center;
}

.tab-actions {
  margin-bottom: 8px;
}

.table-wrap {
  overflow-x: auto;
  overflow-y: visible;
}

.master-table {
  background: #fff;
  font-size: 13px;
}

.master-table th {
  background: #eef2f7;
  white-space: nowrap;
}

.master-table td {
  vertical-align: middle;
  white-space: nowrap;
}


.small-number {
  width: 70px;
}

.medium-number {
  width: 95px;
}

.key-input {
  width: 130px;
}

.name-input {
  width: 180px;
}

.place-input {
  width: 170px;
}

.megrendelo-input {
  width: 260px;
}

.price-input {
  width: 95px;
}

.qty-input {
  width: 110px;
}

.layout-input {
  width: 120px;
}

.megrendelo-cell {
  position: relative;
  min-width: 270px;
}

.megrendelo-suggestions {
  position: absolute;
  z-index: 2000;
  left: 4px;
  right: 4px;
  top: 32px;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #aaa;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.megrendelo-suggestion {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  border: 0;
  background: #fff;
  padding: 5px 8px;
  text-align: left;
  font-size: 12px;
}

.megrendelo-suggestion:hover {
  background: #eef6ff;
}

.cikk-cell {
  position: relative;
  min-width: 220px;
}

.cikk-suggestions {
  position: absolute;
  z-index: 2000;
  left: 4px;
  right: 4px;
  top: 32px;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #aaa;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.cikk-suggestion {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  border: 0;
  background: #fff;
  padding: 5px 8px;
  text-align: left;
  font-size: 12px;
}

.cikk-suggestion:hover {
  background: #eef6ff;
}

/****  felrako */
.tav-cell {
  position: relative;
  min-width: 190px;
}

.tav-suggestions {
  position: absolute;
  z-index: 2000;
  left: 4px;
  right: 4px;
  top: 32px;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #aaa;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.tav-suggestion {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  border: 0;
  background: #fff;
  padding: 5px 8px;
  text-align: left;
  font-size: 12px;
}

.tav-suggestion:hover {
  background: #eef6ff;
}

/**** felhely */
.hely-cell {
  position: relative;
  min-width: 190px;
}

.hely-suggestions {
  position: absolute;
  z-index: 2000;
  left: 4px;
  right: 4px;
  top: 32px;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #aaa;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.hely-suggestion {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  border: 0;
  background: #fff;
  padding: 5px 8px;
  text-align: left;
  font-size: 12px;
}

.hely-suggestion:hover {
  background: #eef6ff;
}

/**** */
.deviza-input {
  width: 75px;
}


/***** erste Zeile  */
.protected-section-row {
  background: #eef6ff;
}

.protected-section-row input,
.protected-section-row select,
.protected-section-row button {
  pointer-events: none;
  background-color: #f1f3f5 !important;
  color: #555;
}

.protected-section-row td {
  opacity: 0.95;
}



/* Szekciók: egy rekord két egymás alatti sorban */
.sections-table-wrap {
  overflow-x: auto;
}

.sections-table {
  width: 100%;
  min-width: 1500px;
  table-layout: fixed;
}

.sections-table th,
.sections-table td {
  padding: 4px;
}

.sections-table td {
  white-space: normal;
}

.sections-table .col-sort {
  width: 72px;
}

.sections-table .col-active {
  width: 52px;
}

.sections-table .col-key-name {
  width: 145px;
}

.sections-table .col-customer-product {
  width: 235px;
}

.sections-table .col-place {
  width: 285px;
}

.sections-table .col-price {
  width: 155px;
}

.sections-table .col-reference {
  width: 220px;
}

.sections-table .col-qty {
  width: 110px;
}

.sections-subheader th {
  background: #f7f9fc;
  color: #4e5968;
  font-weight: 600;
  border-top: 0;
}

.section-record-first td {
  border-top: 2px solid #9ba8b5;
}

.section-record-second td {
  border-bottom: 2px solid #9ba8b5;
}

.section-rowspan-cell {
  vertical-align: middle !important;
  border-bottom: 2px solid #9ba8b5 !important;
}

.sections-table .key-input,
.sections-table .name-input,
.sections-table .place-input,
.sections-table .megrendelo-input,
.sections-table .reference-input,
.sections-table .qty-input {
  width: 100%;
  min-width: 0;
}

.sections-table .megrendelo-cell,
.sections-table .cikk-cell,
.sections-table .tav-cell,
.sections-table .hely-cell {
  position: relative;
  min-width: 0;
}

.price-inline {
  display: flex;
  align-items: center;
  gap: 5px;
}

.sections-table .price-input {
  width: auto;
  min-width: 0;
  flex: 1 1 auto;
}

.sections-table .deviza-input {
  width: 48px;
  min-width: 48px;
  flex: 0 0 48px;
  text-align: center;
}

.sections-table .small-number,
.sections-table .qty-input {
  margin: 0 auto;
}

.sections-table .megrendelo-suggestions,
.sections-table .cikk-suggestions,
.sections-table .tav-suggestions,
.sections-table .hely-suggestions {
  top: calc(100% + 2px);
  left: 3px;
  right: 3px;
}

@media (max-width: 1550px) {
  .sections-table {
    min-width: 1450px;
  }

  .sections-table .col-place {
    width: 255px;
  }

  .sections-table .col-customer-product {
    width: 215px;
  }

  .sections-table .col-reference {
    width: 190px;
  }
}

.fuvarszervezo-input {
  width: 150px;
  min-width: 150px;
}

/***** */
.col-km {
  width: 80px;
}

.km-input {
  max-width: 80px;
  text-align: right;
}


</style>